module.exports = __webpack_public_path__ + "img/select-arrow-white.f463fc3e.svg";